import { render, staticRenderFns } from "./SDCardBooks.vue?vue&type=template&id=766e02c1&"
import script from "./SDCardBooks.vue?vue&type=script&lang=js&"
export * from "./SDCardBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports